const Vue = require('vue')
const $ = require('jquery')

const urlparse = require('url-parse')
const qs = require('qs')

const PhotoSwipe = require('photoswipe')
const PhotoSwipeUI_Default = require('photoswipe/dist/photoswipe-ui-default')
const pswpTemplate = require('templates/components/pswp-element.html')

Vue.component('standalone-gallery', {
    template: `<div></div>`,
    methods: {
        show: function (photos, index = 0) {
            const $body = $('body')

            let pswpElement = null
            if ($body.find('.pswp').length) {
                pswpElement = $body.find('.pswp').get(0)
            } else {
                $body.append(pswpTemplate)
                pswpElement = $body.find('.pswp').get(0)
            }

            const originalPhotos = photos || [];

            if (originalPhotos.length < 1) {
                return
            }

            const realPhotos = originalPhotos.map((photo) => {
                return {
                    src: photo.url,
                    w: photo.width,
                    h: photo.height,
                    title: photo.description || photo.name
                }
            })

            const options = {
                // history & focus options are disabled on CodePen
                history: false,
                arrowKeys: true,
                closeOnScroll: false,
                shareEl: false,
                counterEl: false,
                index: parseInt(index)
            }

            const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, realPhotos, options)
            gallery.init()
        }
    }
})

Vue.component('standalone-property-gallery', {
    template: `<div></div>`,
    methods: {
        show: function (item, index = 0, first = 'photos') {
            const $body = $('body')

            let pswpElement = null
            if ($body.find('.pswp').length) {
                pswpElement = $body.find('.pswp').get(0)
            } else {
                $body.append(pswpTemplate)
                pswpElement = $body.find('.pswp').get(0)
            }

            const originalPhotos = item.photos || [];
            const originalVideos = item.videos || [];

            if (originalPhotos.length < 1 && originalVideos.length < 1) {
                return
            }

            const photos = originalPhotos.map((photo) => {
                return {
                    src: photo.url,
                    w: photo.width,
                    h: photo.height,
                    title: photo.description || photo.name
                }
            })

            const videos = originalVideos.map((video) => {
                const url = urlparse(video.url)
                const querystring = qs.parse(url.query.replace(/^\?/, ''))
                const code = querystring.v
                return {
                    html: `<iframe src="https://youtube.com.br/embed/${code}"></iframe>`
                }
            })

            let items = []

            if (first === 'photos') {
                items = photos.concat(videos)
            } else if (first === 'videos') {
                items = videos.concat(photos)
            }

            const options = {
                // history & focus options are disabled on CodePen
                history: false,
                arrowKeys: true,
                closeOnScroll: false,
                shareEl: false,
                counterEl: false,
                index
            }

            const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options)
            gallery.init()
        }
    }
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/standalone-property-gallery.js